/** Тексты подсказок для spotlight-тура онбординга */
export const ONBOARDING_TOUR_STEPS = {
  profile: {
    title: "Ваша секция",
    description:
      "Название клуба и контакты — их увидят клиенты в записях и сообщениях. Начните отсюда.",
  },
  direction: {
    title: "Направление",
    description:
      "Дзюдо, футбол или своё — это справочник видов спорта. От него зависят группы, не залы.",
  },
  venue: {
    title: "Зал",
    description:
      "Где проходят тренировки. Можно несколько залов — направления с залами не связаны напрямую.",
  },
  group: {
    title: "Группы",
    description:
      "Объединяют направление, зал и список спортсменов. У каждой группы — своё расписание и журнал.",
  },
  schedule: {
    title: "Расписание",
    description:
      "Укажите дни и время — занятия появятся в календаре автоматически.",
  },
  memberships: {
    title: "Тарифы",
    description:
      "Создайте абонементы по занятиям или по сроку — ими будете выдавать клиентам.",
  },
  client: {
    title: "Первый клиент",
    description:
      "Добавьте спортсмена в группу. Абонемент можно выдать сразу или позже.",
  },
  form: {
    title: "Заполните и сохраните",
    description:
      "Введите данные в форме и нажмите кнопку внизу — перейдёте к следующему шагу.",
  },
};
